import axios from 'axios'
import env from '../env'
import qs from 'qs'

const { BRANDID } = Config
export default class ActivityApi {
  static async getActiveCoupons (activityId: number) {
    const Url: string = `${env.MEMBER}/coupon/listBy`
    const res: any = await axios.get(Url, {
      params: {
        activityId,
      }
    })
    return res.error ? res : res.result
  }
  static async getCouponsList (params?: {
    brandId?: number;
    couponIds?: any[];
    page?: number;
    pageSize?: number;
    status?: 'enable' | 'all';
  }) {
    const Url: string = `${env.MEMBER}/coupon`
    const filter: any[] = [
      `brandId||$eq||${BRANDID || params.brandId}`,
    ]
    params && params?.status === 'all' ? '' : filter.push('status||$eq||enable')
    if (params && params.couponIds && params.couponIds.length > 0) {
      filter.push(`couponId||$in||${params.couponIds.join(',')}`)
    }
    const para: any = {
      filter: filter,
      join: ['stores', 'products'],
    }
    if (params.page) para.page = params.page
    if (params.pageSize) para.limit = params.pageSize
    const res: any = await axios.get(Url, {
      params: para,
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      }
    })
    return res.error ? res : res.result
  }
  static async getCouponDetail (id: number) {
    const Url: string = `${env.MEMBER}/coupon/${id}`
    const res: any = await axios.get(Url, {
      params: {
        join: ['stores', 'products'],
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      }
    })
    return res.error ? res : res.result
  }
  // 获取优惠券详情可用餐品
  static async getCouponProducts (id: number) {
    const Url: string = `${env.MEMBER}/coupon/getRelationProducts`
    const res: any = await axios.post(Url, { couponId: id })
    return res.error ? res : res.result
  }
  static async getActiveList (params: {
    type?: string | string[];
    activityId?: number[];
  }) {
    const Url: string = `${env.MEMBER}/activity`
    const s: any = {
      brandId: BRANDID,
    }
    if (params.type) {
      if (Array.isArray(params.type)) {
        s.type = { '$in': params.type }
      } else {
        s.type = params.type
      }
    }
    if (params.activityId) {
      s.activityId = { '$in': params.activityId }
    }
    const res: any = await axios.get(Url, {
      params: {
        sort: 'endTime,DESC',
        s: JSON.stringify(s),
        join: ['exts']
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false })
      }
    })
    return res.error ? res : res.result
  };
  static async getEntryActiveActivity () {
    const Url: string = `${env.MEMBER}/activity/getEntryActiveActivity`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  };
  static async getRedeemList (params?: {
    page?: number;
    pageSize?: number;
  }) {
    const Url: string = `${env.MEMBER}/redeem`
    const s: any = { brandId: BRANDID }
    const para: any = {
      s: JSON.stringify(s),
      sort: 'sysModifyTime,DESC',
    }
    if (params && params.page) para.page = params.page
    if (params && params.pageSize) para.limit = params.pageSize
    const res: any = await axios.get(Url, {
      params: para,
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false })
      }
    })
    return res.error ? res : res.result
  };
  static async getActiveDetail (activeId: number) {
    const Url: string = `${env.MEMBER}/activity/${activeId}`
    const res: any = await axios.get(Url, {
      params: {
        join: ['coupons', 'products', 'exts', 'stores', 'cards'],
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false })
      }
    })
    return res.error ? res : res.result
  };
  static async getPrizeCoupon (params: any) {
    const Url = `${env.MEMBER}/member/prizeCouponActivities`
    return axios.post(Url, { brandId: params.brandId }).then((res: any) => {
      return res.error ? res : res.result
    })
  }
  static async getPartInNum (params: any) {
    const Url = `${env.MEMBER}/member/activityPartInNum`
    return axios.post(Url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
  static async getPrizeTimes (params: any) {
    const Url = `${env.MEMBER}/member/getPrizeTimes`
    return axios.post(Url, params).then((res: any) => {
      return res.error ? res : res.result
    })
  }
  static async getStartPrize (params: any) {
    const Url: string = `${env.MEMBER}/member/startPrize`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async getPrizes (params: any) {
    const Url: string = `${env.MEMBER}/member/prizeCouponList`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async getMemberInfo (params: any) {
    const Url: string = `${env.MEMBER}/open/getMemberInfo`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async invitationRewardList (params: any) {
    const Url: string = `${env.MEMBER}/member/invitationCouponRewardList`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  static async invitationMemberList (params: any) {
    const Url: string = `${env.MEMBER}/member/invitationMemberList`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }
  /** 获取团购商城商品 */
  static async getGroupBuyProduct () {
    const Url: string = `${env.MEMBER}/member/listRedeemProduct`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  }

  static async getGroupBuyProductDetail (redeemProductId: number) {
    const Url: string = `${env.MEMBER}/member/redeemProductDetail`
    const res: any = await axios.post(Url, { redeemProductId })
    return res.error ? res : res.result
  }

  static async getRedeemCoupons (params: any) {
    const Url: string = `${env.MEMBER}/redeem/redeemCoupons`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 手机端活动预约列表 */
  static async getActivityReserveList (params?: any) {
    const Url: string = `${env.ACTIVITY_RESERVATION}/api/v1/activity/app/activities`
    const res: any = await axios.get(Url, {
      params,
      paramsSerializer: params => qs.stringify(params, { indices: false })
    })
    // g-activity 返回 OpenAPI envelope，调用侧按 !res?.errors 判断成功并兼容 data.list。
    return res
  }

  /** 手机端活动预约详情 */
  static async getActivityReserveDetail (activityId: string | number, params?: any) {
    const Url: string = `${env.ACTIVITY_RESERVATION}/api/v1/activity/app/activities/${activityId}`
    const res: any = await axios.get(Url, {
      params,
      paramsSerializer: params => qs.stringify(params, { indices: false })
    })
    return res
  }

  /** 创建活动预约。免费活动直接生成预约，付费活动由后端返回订单号进入支付链路。 */
  static async createActivityReserve (params: any) {
    const Url: string = `${env.MEMBER}/activityReserve/mobile/book`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  /** 我的活动预约列表 */
  static async getActivityReserveRecords (params?: any) {
    const Url: string = `${env.ACTIVITY_RESERVATION}/api/v1/activity/app/bookings`
    const res: any = await axios.get(Url, {
      params,
      paramsSerializer: params => qs.stringify(params, { indices: false })
    })
    return res
  }

  /** 我的活动预约详情 */
  static async getActivityReserveRecordDetail (ordersId: string | number) {
    const Url: string = `${env.ACTIVITY_RESERVATION}/api/v1/activity/app/bookings/${ordersId}`
    const res: any = await axios.get(Url)
    return res
  }

  /** 取消免费活动预约 */
  static async cancelActivityReserve (bookingId: string | number) {
    const Url: string = `${env.MEMBER}/activityReserve/mobile/records/${bookingId}/cancel`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  }

  /** 申请付费活动退款 */
  static async refundActivityReserve (bookingId: string | number) {
    const Url: string = `${env.MEMBER}/activityReserve/mobile/records/${bookingId}/refund`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  }
}
